'use client'
import { Article } from '@/api/types/help-center'
import { cn } from '@/lib/utils'
import slugify from 'slugify'
import useScrollSpy from 'react-use-scrollspy'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'

export function TableOfContents(props: { article: Article }) {
  const router = useRouter()
  const [sectionRefs, setSectionRefs] = useState<React.RefObject<HTMLElement>[]>([])
  useEffect(() => {
    const sections = props.article.headings.map((heading) => {
      const text = getChildrenText(heading)
      const slug = slugify(text, { lower: true })
      const el = document.getElementById(slug) as HTMLElement
      return { current: el }
    })
    setSectionRefs(sections)
  }, [])
  const activeSection = useScrollSpy({
    sectionElementRefs: sectionRefs,
    offsetPx: -120,
    throttleMs: 100
  })
  function getChildrenText(props: any) {
    return props.children
      .map((node: any) => (typeof node === 'string' ? node : node.text || ''))
      .join('')
  }
  function handleMenuItemClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    event.preventDefault()
    const id = event.currentTarget.href.split('#')[1]
    const ref = sectionRefs.find((ref) => ref.current?.id === id)
    window.scrollTo({
      top: (ref?.current?.offsetTop || 0) + 10,
      left: 0,
      behavior: 'smooth'
    })
    router.replace(`#${id}`, { scroll: false })
  }
  if (!props.article.headings) return null
  return (
    <ul className='fixed text-sm leading-6 w-[16.5rem] overflow-y-auto h-[calc(100%-7rem)]'>
      {props.article.headings.map((heading, index) => {
        const text = getChildrenText(heading)
        const slug = slugify(text, { lower: true })
        const isActive = activeSection === index
        const isIndented = heading.style !== 'h2'

        return (
          <li key={index} className={isIndented ? 'pl-4' : ''}>
            <a
              onClick={handleMenuItemClick}
              href={`#${slug}`}
              className={cn(
                isActive ? 'text-primary' : 'hover:text-foreground text-muted-foreground',
                isIndented ? 'font-normal leading-snug' : 'font-medium',
                'py-1 block'
              )}
            >
              {text}
            </a>
          </li>
        )
      })}
    </ul>
  )
}
